import gql from "graphql-tag";

/**
 * @param {string} id
 * @param {string} serialNumber
 * @param {string} condition
 * @param {string} location_id
 * @param {string} manufacturer
 * @param {string} model
 * @param {string} status
 * @param {string} type
 * @param {string} user_id
 */
export const UPDATE_VENTILATOR = gql`
  mutation updateVentilator(
    $id: uuid!
    $serialNumber: String
    $manufacturer: String!
    $model: String!
    $type: String!
    $status: String!
    $condition: String!
    $location_id: uuid!
    $user_id: uuid!
  ) {
    __typename
    update_ventilator(
      where: { id: { _eq: $id } }
      _set: {
        serialNumber: $serialNumber
        condition: $condition
        location_id: $location_id
        manufacturer: $manufacturer
        model: $model
        status: $status
        type: $type
        user_id: $user_id
      }
    ) {
      returning {
        id
      }
    }
  }
`;
